import React from "react";

// Create a new context for sharing the logged in user's auth
// info.
export const AuthContext = React.createContext(null);

// TODO: Move authentication into these effects.
